// httpPorts — the Template BC slice: the built-in template catalogue feeding
// the creation dialog's picker.

import { Result } from "@bilda/utils";
import type { TemplateChoice } from "../../components/MaterialCreate/MaterialCreate.js";
import { getTemplates } from "../httpClient.js";
import type { PortResult } from "../ports/result.js";
import type { TemplatePorts } from "../ports/template.js";
import { fields, list, str } from "../wireShape.js";

// `GET /templates` → the creation dialog's picker. The route serves the
// static built-in shape catalogue (id + title per shape); rows missing an id
// are dropped (forward-compat, same posture as every other list read).

const loadTemplates = async (): PortResult<readonly TemplateChoice[]> => {
    const r = await getTemplates();
    if (Result.isErr(r)) return r;
    const items = list(fields(r.value)?.get("items")).flatMap(
        (raw): readonly TemplateChoice[] => {
            const f = fields(raw);
            const id = str(f?.get("id"));
            if (id === undefined) return [];
            return [{ id, title: str(f?.get("title")) ?? id }];
        },
    );
    return Result.ok(items);
};

export const templateHttp: TemplatePorts = {
    loadTemplates,
};
